import { render, staticRenderFns } from "./districtDashboard.vue?vue&type=template&id=15ce45c4&scoped=true"
import script from "./districtDashboard.vue?vue&type=script&lang=js"
export * from "./districtDashboard.vue?vue&type=script&lang=js"
import style0 from "./districtDashboard.vue?vue&type=style&index=0&id=15ce45c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce45c4",
  null
  
)

export default component.exports